<div class="assay-details-container" [class.print-mode]="isPrintMode">
  <div class="assay-details-body">
    <div class="assay-details-scroll bpx-report" #assayDetailsScroll>
  <!--
    The printed document is unchanged: the run-out of labels below is what has always gone to
    paper. On screen the same values read as the identification card the other tabs use.
  -->
  @if (isPrintView) {
  <app-print-preview-bar
    viewName="Assay Failures"
    [studyName]="studyName"
    [contextLine]="printContextLine"
    [tableColumns]="tableColumns"
    (selectColumns)="handlePrintColumnSelection($event)"></app-print-preview-bar>

  <div class="bpx-detail aa-meta bpx-screen-only">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Panel Name</span>
      <span class="bpx-detail__value">{{ (panelName$ | async) }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Run Type</span>
      <span class="bpx-detail__value">{{ runType }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Test Spec</span>
      <span class="bpx-detail__value">{{ testSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Assignment Spec</span>
      <span class="bpx-detail__value">Final</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Operator</span>
      <span class="bpx-detail__value">{{ operatorName || '-' }}</span>
    </div>
  </div>

  <div class="bpx-print-only">
    <br />
    Panel Name: <span id="panel-name">{{ (panelName$ | async) }}</span><br />
    Run Type: <span id="run-type">{{ runType }}</span><br />
    Test Spec: <span id="test-spec">{{ testSpec }}</span><br />
    Assignment Spec: <span id="assignment-spec">Final</span><br />
    Operator: <span id="operator">{{ operatorName || '-' }}</span><br /><br />
  </div>
  } @else {
  <div class="bpx-detail aa-meta">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Panel Name</span>
      <span class="bpx-detail__value" id="panel-name">{{ (panelName$ | async) }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Run Type</span>
      <span class="bpx-detail__value" id="run-type">{{ runType }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Test Spec</span>
      <span class="bpx-detail__value" id="test-spec">{{ testSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Assignment Spec</span>
      <span class="bpx-detail__value" id="assignment-spec">Final</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Operator</span>
      <span class="bpx-detail__value" id="operator">{{ operatorName || '-' }}</span>
    </div>
  </div>

  <div class="bpx-toolbar__actions aa-actions">
    <a class="bpx-btn" (click)="toggleAllSections(true)">Expand All Sections</a>
    <a class="bpx-btn" (click)="toggleAllSections(false)">Collapse All Sections</a>
    <span class="bpx-toolbar__sep" aria-hidden="true"></span>
    @if (showStabilityOutputs) {
    <a (click)="navigateToPrintView()" class="bpx-btn"
      [class.bpx-btn--disabled]="(isStudySaved$ | async) !== true"
      [attr.aria-disabled]="(isStudySaved$ | async) !== true"
      [style.pointer-events]="((isStudySaved$ | async) !== true) ? 'none' : null">
      <mat-icon fontIcon="print"></mat-icon>Print View
    </a>
    <label class="bpx-check">
      <input
        type="checkbox"
        [checked]="printTruncatedReport"
        (change)="printTruncatedReport = $any($event.target).checked" />
      Print Truncated Report
    </label>
    }
  </div>
  }
  @if (isPrintMode) {
  @for (pageColumns of printPages; track trackByPage; let pageIndex = $index) {
  <div class="bpx-print-page" [class.bpx-print-page--last]="pageIndex === (printPages.length - 1)">
    @if (printPageCaption(pageIndex)) {
    <div class="bpx-print-page-caption">{{ printPageCaption(pageIndex) }}</div>
    }
    <ng-container *ngTemplateOutlet="assayDetailsTableTpl; context: { $implicit: pageColumns }"></ng-container>
  </div>
  }
  } @else {
  <ng-container *ngTemplateOutlet="assayDetailsTableTpl; context: { $implicit: calResponseCombinedData }"></ng-container>
  }

  <ng-template #assayDetailsTableTpl let-pageColumns>
  <table #assayDetailsTable [attr.id]="tableId"
    class="bpx-report__table bpx-report__table--pin-first bpx-report__table--sticky-head assay-details__table"
    [class.assay-detail-print]="isPrintMode" matTableExporter #exporter="matTableExporter">
    <thead class="bpx-report__head">
      <tr>
        <td class="!align-middle">KitLot#</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td class="!align-middle" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem.reportContentItems.lot }}
            <ng-container *ngIf="reportContentItem.valueAssigned === 'AdjustedCalculate'">
              <span class="block">{{ adjustedLabel }}</span>
            </ng-container>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Instrument ID</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
              {{ reportContentItem.reportContentItems.runId }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Assay Name</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{reportContentItem?.reportContentItems?.assay}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Bead Region</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{reportContentItem?.reportContentItems?.region}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Units</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ getUnitsByRegion(reportContentItem.reportContentItems.region)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Result Decimal Precision</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{reportContentItem?.reportContentItems?.resultDecimalPrecision}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>User Defined Decimal Precision</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{reportContentItem?.reportContentItems?.userDefinedDecimalPrecision}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Result Type</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem?.reportContentItems?.resultType }}
          </td>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      @if(isPrintMode) {
      <tr class="subsection-header-print-firstrow bpx-report__section">
        <td>
          Summary Status
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
        (click)="toggleSectionDisplay('summary')" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          Summary Status
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if (isSectionExpanded('summary')) {
      <tr>
        <td>Run Date</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td> {{ getPatientFileData('date') }} </td>
        </ng-container>
      </tr>
      <tr>
        <td>Instrument</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td class="adf-instrument-cell"> {{ getPatientFileData('instrumentSerialNo') }} </td>
        </ng-container>
      </tr>
      <tr>
        <td>Calibrator Lot</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>{{ displayValue(calLots.length ? calLots[0].calLotNumber : null) }}</td>
        </ng-container>
      </tr>
      <tr>
        <td>Control Lot</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>{{ displayValue(qcLots.length ? qcLots[0].masterLotNumber : null) }}</td>
        </ng-container>
      </tr>
      <tr>
        <td>Kit Status PASS/FAIL/ALERT</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.kitStatus)">
              {{ displayValue(materialItem?.runStatus?.kitStatus) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Calibrator Specs Status</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calibratorSpecStatus)">
              {{ displayValue(materialItem?.runStatus?.calibratorSpecStatus) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Patient Sample Specs Status</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.patientSampleSpecStatus)">
              {{ displayValue(materialItem?.runStatus?.patientSampleSpecStatus) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Patient Sample Acceptance Range</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.patientSampleAcceptanceRange)">
              {{ displayValue(materialItem?.runStatus?.patientSampleAcceptanceRange) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Patient Samples: # Run | # Specified</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            {{ displayValue(materialItem?.runStatus?.patientSamplesRun) }} | {{ displayValue(materialItem?.runStatus?.patientSamplesSpecified) }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Negative Samples</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult((runValidityPassFailAlertCount( (materialItem?.regressionStats?.negativeSamplesPASS || 0), (materialItem?.regressionStats?.negativeSamplesFAILED || 0), (materialItem?.regressionStats?.negativeSamplesALERT || 0))) )">
              {{ displayValue(runValidityPassFailAlertCount(
              (materialItem?.regressionStats?.negativeSamplesPASS || 0),
              (materialItem?.regressionStats?.negativeSamplesFAILED || 0),
              (materialItem?.regressionStats?.negativeSamplesALERT || 0))) }}
            </span>

          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Within Cut-off Range Samples</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span
              [ngClass]="getStatusClassFromResult(runValidityPassFailAlertCount((materialItem?.regressionStats?.cutOffSamplesPASS || 0), (materialItem?.regressionStats?.cutOffSamplesFail || 0), (materialItem?.regressionStats?.CutOffSamplesAlert || 0)))">
              {{ displayValue(runValidityPassFailAlertCount((materialItem?.regressionStats?.cutOffSamplesPASS || 0),
              (materialItem?.regressionStats?.cutOffSamplesFail || 0), (materialItem?.regressionStats?.CutOffSamplesAlert
              || 0))) }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Positive Samples</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span
              [ngClass]="getStatusClassFromResult(runValidityPassFailAlertCount((materialItem?.regressionStats?.positiveSamplesPASS || 0), (materialItem?.regressionStats?.positiveSamplesFAILED || 0), (materialItem?.regressionStats?.positiveSamplesAlert || 0)))">
              {{ displayValue(runValidityPassFailAlertCount((materialItem?.regressionStats?.positiveSamplesPASS || 0),
              (materialItem?.regressionStats?.positiveSamplesFAILED || 0),
              (materialItem?.regressionStats?.positiveSamplesAlert || 0))) }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Calibration Curve Validity</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calCurveInformation?.calCurveValidity)">
              {{ displayValue(materialItem?.runStatus?.calCurveInformation?.calCurveValidity) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Calibration Replicate # Validity</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calCurveInformation?.calReplicateValidity)">
              {{ displayValue(materialItem?.runStatus?.calCurveInformation?.calReplicateValidity) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Control Results Validity</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.controlResultsValidity)">
              {{ displayValue(materialItem?.runStatus?.controlResultsValidity) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Sample Replicate # Validity</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.sampleReplicateCountValidity)">
              {{ displayValue(materialItem?.runStatus?.sampleReplicateCountValidity) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Sample Replicate CV Validity</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td>
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.sampleReplicateCVValidity)">
              {{ displayValue(materialItem?.runStatus?.sampleReplicateCVValidity) | uppercase }}
            </span>
          </td>
        </ng-container>
      </tr>
      }
      @for (section of sections; track trackBySection; let sectionIndex = $index) {
      @if (isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td>
          {{ section.title }}
          @if (section.status) {
          - <span [ngClass]="getSectionStatusClass(section.status)">{{ getSectionStatusLabel(section.status) }}</span>
          }
        </td>
        <td [attr.colspan]="pageColumns.length">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section subsection-header"
        (click)="toggleSectionDisplay(section.id)" title="Click to show/hide section">
        <td class="collapsed-section-header collapsed-section-label">
          {{ section.title }}
          @if (section.status) {
          - <span [ngClass]="getSectionStatusClass(section.status)">{{ getSectionStatusLabel(section.status) }}</span>
          }
        </td>

        <td [attr.colspan]="pageColumns.length"></td>
      </tr>
      }
      @if (isSectionExpanded(section.id) && shouldRenderSection(sectionIndex)) {
      @for (row of section.rows; track trackByRow) {
      <tr>
        <td [attr.title]="!isPrintMode && row.title ? row.title : null">{{ row.label }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
          <td [ngClass]="getCellClass(section, row, materialItem)">
            @if (section.id === 'discard') {
              @if (isPrintMode) {
                <div class="discard-reason discard-reason--print">
                  <div class="discard-reason-line" *ngFor="let line of getDiscardReasonLines(materialItem, row.accession)">
                    {{ line }}
                  </div>
                </div>
              } @else {
                <span class="discard-reason"
                  [class.discard-reason--clickable]="hasDiscardReason(materialItem, row.accession)"
                  [title]="hasDiscardReason(materialItem, row.accession) ? 'Click to see the full reason' : ''"
                  (click)="openDiscardReasonDialog(materialItem, row.accession)">
                  {{ getCellText(section, row, materialItem) }}
                </span>
              }
            } @else {
              {{ getCellText(section, row, materialItem) }}
            }
          </td>
        </ng-container>
      </tr>
      }
      }
      }
    </tbody>
        <tfoot class="bpx-print-spacer-footer">
          <tr>
            <td [attr.colspan]="(pageColumns.length || 0) + 1">
              <div class="bpx-print-footer-spacer" aria-hidden="true"></div>
            </td>
          </tr>
        </tfoot>
  </table>
  </ng-template>
  @if (!isPrintMode && !calResponseCombinedData.length) {
  <p class="bpx-empty">No assay results to display.</p>
  } @else if (!isPrintMode && !sections.length) {
  <p class="bpx-empty">No assay failures to display.</p>
  }
    </div>
  </div>
</div>

@if (isPrintMode) {
<div class="header">
  Bio-Rad Laboratories<br />
  Redmond, WA
</div>
<div class="print-footer-cutoff" aria-hidden="true"></div>
<div class="footer">
  <div class="print-footer-left">
    {{ studyName || '-' }}<br />
    {{ (panelName$ | async) || '-' }} : Spec Rev {{ specVersion || '-' }}<br />
    Web App Version: {{ appVersion || '-' }}
  </div>
</div>
}
